import { IMigrationState } from './migration.types'

export const MigrationState: IMigrationState = {
  show: false,
  data: null
}
